import md5 from 'md5';

/**
 * Generates a Gravatar URL based on the provided email address.
 *
 * @param email - The email address used to generate the Gravatar URL. Defaults to an empty string.
 * @return The Gravatar URL corresponding to the MD5 hash of the provided email address.
 */
export function getGravatarUrl(email: string = '') {
  return `https://www.gravatar.com/avatar/${md5(email)}`;
}
